import React, { useState, useEffect } from "react";
import PostCardSideBar from "./QuestionCardSideBar";
import { useQuestionContext } from "../../shared/context/QuestionContext";
import { useTranslation } from "react-i18next";

export default function QuestionSideBar() {
  const { t } = useTranslation();
  const Lng = localStorage.getItem("lang");
  const [questions, setQuestions] = useState([]);
  const { getQuestionsByFilter } = useQuestionContext();
  useEffect(() => {
    async function fetchQuestions() {
      const response = await getQuestionsByFilter({
        limit: 4,
        // Only published questions: pending ones are still awaiting review.
        filter: {
          language: Lng,
          status: "published",
        },
      });
      setQuestions(response.data?.questions ?? []);
    }
    fetchQuestions();
  }, [getQuestionsByFilter]);

  if (!questions?.length) return null;
  return (
    <div className="avc-sidebar-card">
      <h2 className="avc-sidebar-card__title">{t("qa_latest")}</h2>
      <ul className="avc-qa-latest">
        {questions.map((question) => (
          <PostCardSideBar key={question._id} question={question} />
        ))}
      </ul>
    </div>
  );
}
